import { PreviewType } from './types';

export const FULL_PREVIEW_TYPES = [
  PreviewType.BASIC_TIMELINE_FULL_PREVIEW,
  PreviewType.ADVANCED_TIMELINE_PREVIEW_FROM_SEEKER,
  PreviewType.STORYBOARD_FULL_PREVIEW,
];
